module.exports = __webpack_public_path__ + "img/2016_no.c7cec507.svg";